import React, { useState } from 'react';
import './ProductoDetalle.css';
import { useCart } from '../context/CartContext';

const ProductoDetalle = ({ producto, onClose, productosRelacionados }) => {
  const [cantidad, setCantidad] = useState(1);
  const { addToCart } = useCart();
  
  if (!producto) return null;

  const handleAddToCart = () => {
    addToCart(producto, cantidad);
  };

  return (
    <div className="producto-detalle-overlay" onClick={onClose}>
      <div className="producto-detalle-container" onClick={(e) => e.stopPropagation()}>
        <button className="btn-cerrar" onClick={onClose}>✕</button>
        
        <div className="detalle-content">
          {/* Imagen principal */}
          <div className="detalle-imagen-section">
            <img src={producto.imagen} alt={producto.nombre} className="detalle-imagen-principal" />
          </div>

          {/* Información del producto */}
          <div className="detalle-info-section">
            <span className="detalle-linea">{producto.linea}</span>
            <h1 className="detalle-nombre">{producto.nombre}</h1>
            <p className="detalle-variedad">{producto.variedad}</p>
            
            {producto.descripcion && (
              <p className="detalle-descripcion">{producto.descripcion}</p>
            )}

            <div className="detalle-caracteristicas">
              <div className="caracteristica-item">
                <span className="caracteristica-label">Tipo</span>
                <span className="caracteristica-valor">{producto.variedad}</span>
              </div>
              <div className="caracteristica-item">
                <span className="caracteristica-label">Línea</span>
                <span className="caracteristica-valor">{producto.linea}</span>
              </div>
              <div className="caracteristica-item">
                <span className="caracteristica-label">Temperatura</span>
                <span className="caracteristica-valor">16-18°C</span>
              </div>
            </div>

            <div className="detalle-compra">
              <span className="detalle-precio">${producto.precio}</span>
              <div className="detalle-cantidad">
                <button className="btn-cantidad" onClick={() => setCantidad(Math.max(1, cantidad - 1))}>-</button>
                <span className="cantidad-numero">{cantidad}</span>
                <button className="btn-cantidad" onClick={() => setCantidad(cantidad + 1)}>+</button>
              </div>
              <button className="btn-agregar-carrito" onClick={handleAddToCart}>AGREGAR AL CARRITO</button>
            </div>
          </div>
        </div>

        {/* Productos Relacionados */}
        {productosRelacionados && productosRelacionados.length > 0 && (
          <div className="productos-relacionados-section">
            <h3 className="relacionados-titulo">PRODUCTOS RELACIONADOS</h3>
            <div className="relacionados-grid">
              {productosRelacionados.map(prod => (
                <div key={prod.id} className="relacionado-card">
                  <div className="relacionado-imagen">
                    <img src={prod.imagen} alt={prod.nombre} />
                  </div>
                  <div className="relacionado-info">
                    <span className="relacionado-linea">{prod.linea}</span>
                    <h4 className="relacionado-nombre">{prod.nombre}</h4>
                    <span className="relacionado-precio">${prod.precio}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductoDetalle;
